import { store } from "..";
import { addTab } from "../common/sysco-ui-components/store/actions/tabViewAction";
import docDetailsContainer from "../containers/docDetailsContainer";

export const toggleSearch = (component) => {   
    component.setState((prevState) => ({
        showSearch: !prevState.showSearch,
    }));
};

export const showDetails = (data) => {
    store.dispatch(addTab("Document Details : "+data.nodeId, docDetailsContainer,{id:data.nodeId,docType:data.DocumentType[0].replace("/", "-")}));
}

export const defaultFilterMethod = (filter, row) => {
    const rowValue = row[filter.id];
    if (rowValue !== undefined) {
        return String(rowValue).toLowerCase().includes(filter.value.toLowerCase());
    }
    return false;
};